module.exports = __webpack_public_path__ + "static/media/space-sample-video.52bc0536.mp4";